import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login-service-provider',
  templateUrl: './login-service-provider.component.html',
  styleUrls: ['./login-service-provider.component.scss'],
  standalone: false,
})
export class LoginServiceProviderComponent {
  @ViewChild('createTicketForm') createTicketFormRef?: ElementRef;

  constructor(private router: Router) {}

  scrollToForm(): void {
    this.createTicketFormRef?.nativeElement.scrollIntoView({
      behavior: 'smooth',
    });
  }

  navigateTo(route: string): void {
    this.router.navigateByUrl(route);
  }
}
